export default __webpack_public_path__ + "static/sovrn-f7bb6f8041c2ce614fd722d693be5c0b.svg";